import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts";

export default class extends Controller {
  static values = {
    data: Object
  }

  connect() {
    const options = {
      chart: { 
        type: 'heatmap',
        toolbar: {
          show: false
        }
      },
      colors: ['#508251'],
      series: this.dataValue.series,
      dataLabels: {
        style: {
          fontSize: '12px',
          colors: ['#000000']
        }
      },
      tooltip: {
        enabled: false
      },
      yaxis: {
        show: false
      },
      title: { enabled: false },
      grid: {
        padding: { top: 0 }
      }
    };
    const chart = new ApexCharts(document.querySelector("#chart"), options);
    chart.render();
  }
}